import { useSiteMedia } from "@/context/SiteMediaContext";
import { ShieldCheck, Fingerprint, Cpu } from "lucide-react";
import { useLanguage } from "@/i18n/LanguageContext";

const VALUE_ICONS = [ShieldCheck, Fingerprint, Cpu];

export default function About() {
  const media = useSiteMedia();
  const { T } = useLanguage();
  return (
    <div className="pt-20" data-testid="about-page">
      <section className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-16 items-center px-6 lg:px-16 py-12 md:py-16 max-w-[1600px] mx-auto">
        <div className="lg:col-span-7 relative h-[420px] lg:h-[640px] overflow-hidden order-2 lg:order-1">
          <img src={media.about_portrait} alt="Carolina Aguiar" className="w-full h-full object-cover" />
        </div>
        <div className="lg:col-span-5 order-1 lg:order-2">
          <p className="text-[11px] tracking-[0.25em] uppercase text-[#9B6179] mb-4">{T.about.eyebrow}</p>
          <h1 className="font-serif text-4xl lg:text-5xl text-[#9B6179] mb-8 leading-tight">{T.about.full_title}</h1>
          <div className="space-y-5 text-[#090708]/65 leading-relaxed max-w-md">
            <p>{T.about.full_p1}</p>
            <p>{T.about.full_p2}</p>
          </div>
          <p className="font-script text-3xl text-[#9B6179] mt-8">{T.about.signature}</p>
        </div>
      </section>

      <section className="px-6 lg:px-16 py-12 md:py-16 max-w-3xl mx-auto">
        <p className="text-[11px] tracking-[0.25em] uppercase text-[#9B6179] mb-10 text-center">{T.about.values_title}</p>
        <div className="flex flex-col divide-y divide-[#090708]/8">
          {T.about.values.map((v, i) => {
            const Icon = VALUE_ICONS[i];
            return (
              <div key={i} className="flex items-center gap-6 py-6" data-testid={`about-value-${i}`}>
                <Icon className="w-6 h-6 text-[#9B6179] shrink-0" strokeWidth={1.5} />
                <div>
                  <p className="font-serif text-xl text-[#090708]">{v.t}</p>
                  <p className="text-sm text-[#090708]/50 mt-1">{v.d}</p>
                </div>
              </div>
            );
          })}
        </div>
      </section>
    </div>
  );
}
